export const formatPriceToEma = (value?: number | null) =>
	value == null ? "" : value === 0 ? "Cross" : value < 0 ? "Above" : "Below";

export const formatEps = (value?: number) =>
	value == null || value === 0 ? "" : value > 0 ? "Beat" : "Miss";

export const formatImproving = (value?: number) =>
	value == null || value === 0 ? "" : value > 0 ? "Improving" : "Deteriorating";

export const formatPositive = (value?: number) =>
	value == null || value === 0 ? "" : value > 0 ? "Positive" : "Negative";

export const formatOutPerfSpy = (value?: number) =>
	value == null ? "" : value > 0 ? "Yes" : "No";

export const formatPositiveRMRSlope = (value?: number) =>
	value == null
		? ""
		: value === 0
			? "Consolidating"
			: value > 0
				? "Positive"
				: "Negative";
